import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppAndroid from './android/App';
import { Capacitor } from '@capacitor/core';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const isNative = Capacitor?.isNativePlatform?.();
const platform = Capacitor?.getPlatform?.();
const useMobileApp = isNative && (platform === 'android' || platform === 'ios');
root.render(useMobileApp ? <AppAndroid /> : <App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
